import { IInterceptorError } from '../types/@interceptor';

export const getAuthErrorMessage = (error: IInterceptorError | undefined): string => {
  if (!error) {
    return 'Something went wrong. Please try again.';
  }

  if (Array.isArray(error.message)) {
    const text = error.message.filter(Boolean).join('. ');
    return text || 'Something went wrong. Please try again.';
  }

  if (typeof error.message === 'string' && error.message.trim()) {
    return error.message;
  }

  if (error.error) {
    return String(error.error);
  }

  return 'Something went wrong. Please try again.';
};
